module.exports = __webpack_public_path__ + "img/巴音王子.1b360140.jpg";